import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../ui";
import { Sidebar } from "./Sidebar";
import { cn } from "@/lib/utils";
import { Header } from "./Header";

const Layout = () => {
  return (
    <>
      <SidebarProvider>
        <div className="flex flex-row">
          <main className="bg-secondary text-white fixed h-[100%] mt-[50px] pt-5 w-[280px] hidden lg:block">
            <Sidebar />
          </main>
          <div>
            <Header />
            <div
              className={cn(
                "w-[100vw] mt-[50px] bg-[#F4F5F8] min-h-screen text-start transition-all duration-300 ease-in-out",
                "lg:w-[calc(100vw-280px)] lg:ml-[280px]"
              )}
            >
              <Outlet />
            </div>
            {/* <footer className="bg-white">Footer</footer> */}
          </div>
        </div>
      </SidebarProvider>
    </>
  );
};

export default Layout;
